import { Modal } from 'react-bootstrap-v5'
import RelatoriosService from '../../services/RelatoriosService';
import { useEffect, useState, useCallback } from 'react';
import Table from './table';

const ModalResumo = ({ show, toggleModal, esteiraID, esteira, empresaID }: { show: boolean, toggleModal: Function, esteiraID: number, esteira: any, empresaID: number }) => {


    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {

        const get = async () => {
            setLoading(true);
            const rows = await RelatoriosService.obterResumoConstancia(esteiraID);
            setRows(rows);
            setLoading(false);
        }

        get();

    }, [esteiraID])

    const TableRender = useCallback(() => (
        <Table data={rows} esteira={esteira} empresaID={empresaID} />
    ), [rows]);

    return (
        <Modal fullscreen centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#212529', color: 'white' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase', color: 'white' }}>Análise Horizontal</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <button onClick={() => toggleModal()} style={{ backgroundColor: 'transparent', border: 'none' }}>
                            <i className="fas fa-times" style={{ color: 'white' }}></i>
                        </button>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {loading ? (
                            <div className='col-md-4 mt-2'>
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    Aguarde...
                                </span>
                            </div>
                        ) : (
                            <div className="col-md-12 mt-2" >
                                <TableRender />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ModalResumo